/**
 * 招待リンク /link-google?token=xxx で開くページ。
 * 認可 URL を取得して Google にリダイレクトする（連携対象本人が連携するフロー）。
 */
import { useEffect, useState } from "react";

export function LinkGooglePage() {
  const [status, setStatus] = useState<"loading" | "redirecting" | "error">("loading");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token") ?? params.get("inviteToken");
    if (!token) {
      setError("招待リンクが無効です（token がありません）");
      setStatus("error");
      return;
    }
    fetch(`/api/auth/google/url?inviteToken=${encodeURIComponent(token)}`)
      .then(async res => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          setError((data as { error?: string }).error ?? "リンクの有効期限が切れているか、無効です");
          setStatus("error");
          return;
        }
        const url = (data as { url?: string }).url;
        if (url) {
          setStatus("redirecting");
          window.location.href = url;
        } else {
          setError("認可 URL の取得に失敗しました");
          setStatus("error");
        }
      })
      .catch(() => {
        setError("通信に失敗しました");
        setStatus("error");
      });
  }, []);

  if (status === "loading" || status === "redirecting") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-4 bg-background">
        <p className="text-muted-foreground">
          {status === "redirecting" ? "Google に移動しています…" : "読み込み中…"}
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-4 bg-background">
      <p className="text-destructive text-center">{error}</p>
    </div>
  );
}
